import React from "react";

import {
  Box,
  BoxDiv,
  ThemeColors,
  ThemeRadii,
  ThemeShadows
} from "../../foundations";

export type CardProps = {
  children?: React.ReactNode;
  surfaceColor?: ThemeColors;
  borderColor?: ThemeColors;
  borderRadius?: Exclude<ThemeRadii, "radius-round">;
  dropShadow?: ThemeShadows;
} & BoxDiv;

export const Card: React.FC<CardProps> = ({
  surfaceColor,
  borderColor,
  borderRadius,
  dropShadow,
  children
}) => {
  return (
    <Box
      sx={{
        backgroundColor: surfaceColor
          ? surfaceColor
          : "surface-neutral-default",
        border: "1px solid",
        borderColor: borderColor ? borderColor : "stroke-neutral-tertiary",
        borderRadius: borderRadius ? borderRadius : "radius-2",
        boxShadow: dropShadow ? dropShadow : "none",
        width: "fit-content"
      }}
    >
      {children}
    </Box>
  );
};
